import { call, put } from 'redux-saga/effects'

import { fetchDataWorker } from '../../apiRequest/saga/worker'
import { USER } from '../types'

import { userAPI } from '@/api/userAPI'
import { setUserDataAction } from '@/bus/user'

export function* updateUserInfoWorker({ payload }: any) {
  const token = localStorage.getItem('access_token')

  if (!token) {
    return
  }

  // @ts-ignore
  const { response } = yield call(fetchDataWorker, {
    api: userAPI.updateUserInfo,
    type: USER,
    params: { token, params: payload }
  })
}

export function* userInfoWorker() {
  const token = localStorage.getItem('access_token')

  if (!token) {
    yield put(setUserDataAction({ data: {}, loaded: false, hasToken: false }))
    return
  }

  yield put(setUserDataAction({ data: {}, loaded: false, hasToken: true }))

  // @ts-ignore
  const { response } = yield call(fetchDataWorker, {
    api: userAPI.getUserInfo,
    type: USER,
    params: { token }
  })

  if (response?.status === 'success') {
    yield put(setUserDataAction({ data: response.data, loaded: true }))
  }
}
